import React from 'react'
import { Message } from '../Message/'
import { Stack } from '~/styles'

type WelcomeMessageProps = {
  greeting?: string
}

export const WelcomeMessage = ({ greeting }: WelcomeMessageProps): JSX.Element => {
  const greetingDoesNotExist = !greeting

  if (greetingDoesNotExist) return <></>

  return (
    <Message.RootLeft>
      <Message.UserAvatar iconName="MiMaleDoctor" />
      <Stack spacing="0.5rem" alignItems="flex-start">
        <Message.UserName username="IA Interativa" />
        <Message.FromLeft>
          <Message.PlainText text={greeting} />
        </Message.FromLeft>
      </Stack>
    </Message.RootLeft>
  )
}
